import request from '../request'

export const fetchSchoolRecruitsList = (params) => {
  return request({
    url: '/v3/school_recruits',
    method: 'GET',
    params
  })
}

export const fetchSchoolRecruitOverview = () => {
  return request({
    url: '/v3/school_recruits/statistics',
    method: 'GET'
  })
}

export const changeRecruiteStep = (id, data) => {
  return request({
    url: `/v3/school_recruit_steps/${id}`,
    method: 'POST',
    data
  })  
}

export const fetchCampusRecuriteSteps = (params) => {
  return request({
    url: '/v3/school_recruit_steps',
    method: 'GET',
    params
  })
}